import Ajax from '@shared/utils/ajax'
import { getMsgByErrCode } from '@shared/utils/errCode'
import HmacMD5 from 'crypto-js/hmac-md5'
import Hex from 'crypto-js/enc-hex'
import { RetCode } from './bussinessCode.js'
import { ClientSetUserInfo } from '@/api/clientApi.js'
import { isDevOrTest } from '@/common/const.js'
// import { reportLoginShow, showLoginByChannel } from '@/common/business.js'

const getSecret = (body) => {
  body = JSON.stringify(body)
  const key = 'sfjfkj8328qwisvig389389bvizscdwf'
  return HmacMD5(body, key).toString(Hex)
}

const requestDataFn = function (opt) {
  const userInfo = window?.app?.$store?.state.userInfo || {}
  const data = opt.data || {}
  const common = {
    token: userInfo.token || '',
    app_id: '104'
  }

  opt.data = Object.assign({ common }, data)
  opt.headers = { ...opt.headers, 'X-Cf-Authorization': getSecret(opt.data) }
  return opt
}

const responseSuccessFn = function (res) {
  const data = res.data || {}

  if (!data.resp_common || data.resp_common.ret !== 0) {
    const ret = data.resp_common.ret

    const arr = [4001002, 4001004]

    if (arr.includes(ret)) {
      // alert('登录过期' + JSON.stringify(window?.app?.$store?.state.userInfo || ''))
      // 登录过期
      // https://cheetahfun.feishu.cn/docs/doccnUBp0grFLnNDFyWrnmQ2gLy#fnNpbL
      ClientSetUserInfo({})
      // 防止token失效重复弹窗
      // reportLoginShow()
      // showLoginByChannel()
    }

    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
      ret,
      msg: RetCode[ret] || getMsgByErrCode(data.resp_common.ret) || '网络错误！'
    })
  }

  return {
    ret: data.resp_common.ret,
    data: data
  }
}

const responseFailFn = function (err) {
  // eslint-disable-next-line prefer-promise-reject-errors
  return Promise.reject(err)
}

const ajax = new Ajax({
  default: {
    method: 'POST',
    headers: { 'X-Cf-From': 'ppt', 'X-Cf-Productid': '104' }, // 后端区分服务
    retry: {
      times: 0,
      delay: 200
    },
    baseUrl: isDevOrTest ? 'http://baoquvip.aix-test-k8s.iweikan.cn' : 'https://api-officevip.keniu.com',
    requestDataFn,
    responseSuccessFn,
    responseFailFn
  }
})

const preHandle = ajax.preHandle.bind(ajax)

const keniuApi = {
  getWxmpLoginQr: preHandle({ url: '/account/wx/official_account/login_qrcode' }),
  queryWxmpLoginResult: preHandle({ url: '/account/wx/official_account/is_follow' }),
  getSmsCode: preHandle({ url: '/sms/send_code' }),
  getCaptcha: preHandle({ url: '/sms/captcha' }),
  checkCaptcha: preHandle({ url: '/sms/check_captcha' }),
  mobileLogin: preHandle({ url: '/account/login/phone' }),
  qqLogin: preHandle({ url: '/account/login/qq_web' }),
}

export default keniuApi
